/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * @emails react-core
 * @flow
 */

// $FlowExpectedError
import navArticoli from '../../content/articoli/nav.yml';
// $FlowExpectedError
import navLibri from '../../content/libri/nav.yml';
// $FlowExpectedError
import navBiografia from '../../content/biografia/nav.yml';

const sectionListLibri = navLibri.map((item: Object): Object => ({
  ...item,
  directory: 'libri',
}));

const sectionListArticoli = navArticoli.map((item: Object): Object => ({
  ...item,
  directory: 'articoli',
}));

export {
  sectionListArticoli,
  sectionListLibri,
  navBiografia as sectionListBiografia,
};
